module.exports = __webpack_public_path__ + "static/media/chevron-down.36cf5b4b.svg";